import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import DetailTemplate from './detailTemplate'
import { getTemplateThunk } from './detailTemplate/store/thunk'
import Templates from './templates'

export const PreferenceSetting = ({ template, detailTemplate }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { showTemplates } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const setIsShowDetail = (val) => {
    const params = `?${!val ? '&showTemplates=true' : ''}`
    navigate(detailTemplate.path + params)
  }

  const goToTemplateTable = () => setIsShowDetail(false)

  const backToDetailTemplate = () => navigate(-1)

  const openTemplate = (data) => {
    dispatch(getTemplateThunk({ Id: data.id }))
    backToDetailTemplate()
  }

  if (showTemplates === 'true') {
    return (
      <Templates
        backToDetailTemplate={backToDetailTemplate}
        template={template}
        openTemplate={openTemplate}
        setIsShowDetail={setIsShowDetail}
      />
    )
  }

  return (
    <DetailTemplate
      goToTemplateTable={goToTemplateTable}
      detailTemplate={detailTemplate}
    />
  )
}

PreferenceSetting.propTypes = {
  template: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        templateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    ).isRequired,
    ids: PropTypes.array.isRequired,
    callApi: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    total: PropTypes.number,
    deleteTemplate: PropTypes.func.isRequired,
    updateTemplate: PropTypes.func.isRequired,
  }).isRequired,
  detailTemplate: PropTypes.shape({
    saveTemplate: PropTypes.func,
    path: PropTypes.string,
  }).isRequired,
}

PreferenceSetting.defaultProps = {
  handleBack: () => {},
}
